import * as core from '../../../../../../../core'

import { query } from './yearly-revenue-table.query'

export const RESOURCE = {
  payload: {
    alias: 'yearly.revenue.table',
    description: 'Table showing yearly revenue by organization and month',
    name: 'Yearly Revenue Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
